/**
 * @copyright Schweizerische Bundesbahnen SBB
 * @class StartupInfo
 * @version: 0.0.1
 * @since September 2017
 * @description The StartInfo stores loading-information during startup
 */
export class StartupInfo {
  private _title: string;
  private _startTime: number;
  private _endTime: number;

  public start() {
    this._startTime = performance.now();
  }

  public done() {
    this._endTime = performance.now();
  }

  public get isDone(): boolean {
    return this._endTime !== undefined;
  }

  public get isLoading(): boolean {
    return this._startTime !== undefined && this._endTime === undefined;
  }

  public get title(): string {
    return this._title;
  }

  public setTitle(title: string) {
    this._title = title;
  }
}
